export default "__VITE_ASSET__DJFeYTd5__"